import { render } from "./dentrion_footer.vue?vue&type=template&id=3698178d&scoped=true"
import script from "./dentrion_footer.vue?vue&type=script&lang=js"
export * from "./dentrion_footer.vue?vue&type=script&lang=js"

import "./dentrion_footer.vue?vue&type=style&index=0&id=3698178d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3698178d"]])

export default __exports__